module.exports = __webpack_public_path__ + "img/bg-1.20880143.png";